var _rect, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParentheses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 72,
    viewBox: "0 0 143 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 142,
    height: 71,
    rx: 9.5,
    fill: "white",
    stroke: "#12489E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 11,
    width: 50,
    height: 51,
    fill: "url(#pattern0_115_97)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_115_97",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_115_97",
    transform: "scale(0.02 0.0196078)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_115_97",
    width: 50,
    height: 51,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAUDBAQEAwUEBAQFBQUGBwwIBwcHBw8LCwkMEQ8SEhEPERETFhwXExQaFRERGCEYGh0dHx8fExciJCIeJBweHx7/2wBDAQUFBQcGBw4ICA4eFBEUHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh7/wAARCAAzADIDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD4yooooAKK9H8T/BH4keHvB8fi+90AzaG8KXH2u2mSVRE4BVyFOdpBBzjA74rG8HfDbxn4x0O91jwvosmr29i226S2kUyxZGQTGTuIODjAPQ+lAHI0VJcQzW88lvcRPDNGxSSN1KsjA4IIPIIPao6ACiiigAooooA/Tj4URpdfsiaRDcqJY38KMjK/IK+Swx9McV8o/wDBPnULu1+PLWUMjC3vdKuEnTPBClXUn3BH6n1r6w+Dv/JpWi/9iu3/AKKavi39mb4n+E/hHc6r4mv9Jv8AV/ENxAbSzhiKpDDGSGZmY85Yqo46AH1oA63/AIKGeHtJ0f4vadqWmwxwXGraaJ7xEGN0iuyCQj1KgD/gNfNVdd8XPiBrnxL8b3finXmQTTARwwR/6u3iX7sa+wyTnuST3rkaACiiigAooooA++ofjF8PPAX7MGn6APFWl6vrsXh9bJbKwuFmb7Q0WCrFeAqsxyT2FfAtFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFAH/9k="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentheses);
export default __webpack_public_path__ + "static/media/Parentheses.01d66e0845b61f66a2378511c35e3d7e.svg";
export { ForwardRef as ReactComponent };